import React from "react";
import { Outlet, Navigate } from "react-router-dom";

const Privateroutes = ({ auth }) => {
  return auth ? <Outlet /> : <Navigate to="/login" />;
};

export default Privateroutes;
